var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24.004,
    viewBox: "0 0 24.001 24.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "layer-plus",
    d: "M.485,8.088l9.862,5.917a3.206,3.206,0,0,0,3.306,0l9.861-5.917a1,1,0,0,0,0-1.714L13.654.456a3.2,3.2,0,0,0-3.307,0L.485,6.373a1,1,0,0,0,0,1.714ZM11.376,2.171h0a1.215,1.215,0,0,1,1.248,0l8.432,5.06-8.432,5.06a1.217,1.217,0,0,1-1.249,0L2.944,7.23ZM24,20a1,1,0,0,1-1,1H21v2a1,1,0,0,1-2,0V21H17a1,1,0,0,1,0-2h2V17a1,1,0,0,1,2,0v2h2A1,1,0,0,1,24,20ZM12.857,23.286a1,1,0,0,1-1.372.342l-11-6.6a1,1,0,0,1,1.029-1.715l11,6.6A1,1,0,0,1,12.857,23.286Zm11-12.2a1,1,0,0,1-.343,1.372l-11,6.6a1,1,0,0,1-1.03,0l-11-6.6a1,1,0,0,1,1.029-1.715L12,17.038l10.485-6.291a1,1,0,0,1,1.372.343Z",
    transform: "translate(0.001 0.004)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/create-icon.6b9e79fd722e99f6ab59d4677d6f030e.svg";
export { ForwardRef as ReactComponent };